module.exports = __webpack_public_path__ + "static/cf-reg-52d88b2a7b5f53f83bd46ee6e16e24b9.ttf";